<template>
  <div ref="captchaContainer" id="captchaContainer">
    <VueTurnstile
      :sitekey="sitekey"
      theme="light"
      size="normal"
      @verify="verify"
      ref="turnstileComponent"
    />
  </div>
</template>

<script>
import VueTurnstile from "./VueTurnstile.vue";
import { turnstileSiteKey } from "../../../turnstile.config";

export default {
  name: "App",
  components: {
    VueTurnstile,
  },
  data() {
    return {
      sitekey: turnstileSiteKey,
    };
  },
  methods: {
    /**
     * Triggers the re-render of the captchaComponent by calling its resetComponent method.
     * This method is used when the parent component needs to force a re-render or reset
     * of the captchaComponent, typically in response to specific events or data changes
     * in the parent component.
     */
    resetChild() {
      this.$refs.turnstileComponent.reset(); //loadTurnstileScript(); // Invoking resetComponent on the child component
    },
    verify(token) {
      this.$emit("tokenReceived", token);
    },
  },
};
</script>
